<template>
  <HeaderComponent></HeaderComponent>
  <main>
    <router-view :key="$route.path"/>
  </main>
  
</template>
<script>
import HeaderComponent from './components/HeaderComponent.vue';
export default {
  name: 'App',
  components:{
    HeaderComponent
  }
}
</script>
